import { CounterpartyType } from '@/constants/CounterpartyType';
import { Period } from '@/constants/DateTimeConstants';
import { TaxObligationStatus } from '@/constants/TaxObligationStatus';
import {BalanceEffect, PaymentStatus, TransactionType} from '@/constants/PaymentConstants';
import { Risk } from '@/constants/Risk';
import FileMetaDTO from "@/dto/files/FileMetaDTO";
import { TaxReportForm } from "@/constants/TaxReportForm";
import { TaxObligationLiability } from "@/dto/tax/TaxObligationPayload";
import { TaxObligationLiabilityType } from "@/constants/TaxObligationLiabilityType";

export enum TaxObligationReconciliationStatus {
    NOT_VERIFIED = 'NOT_VERIFIED',
    MATCHED = 'MATCHED',
    DIFFERENCE_FOUND = 'DIFFERENCE_FOUND',
    RESOLVED = 'RESOLVED'
}

export interface TaxObligationReconciliationRecordDTO {
    id: number;
    agencyBalanceCents: number;
    internalBalanceCents: number;
    differenceCents: number;
    verificationDate: string;
    reconciliationStatus: TaxObligationReconciliationStatus;
    comment: string | null;
    document: FileMetaDTO | null;
}

export interface TaxObligationCommentDTO {
    id: number;
    comment: string;
    leftByName: string;
    createdAt: string; // Instant mapped to ISO string
}

export interface TaxObligationLedgerRecordDTO {
    id: number;
    date: string;
    order: number;
    amountCents: number;
    balanceEffect: BalanceEffect;
    transactionType: TransactionType;
    balanceSnapshot: number;
    liabilityType?: TaxObligationLiabilityType;
    paymentId?: number;
    paymentMethod?: string;
    paymentAccount?: string;
}

export default interface TaxObligationDTO {
    id: number;
    year: number;
    period: Period;
    periodStart: string | null;
    periodEnd: string | null;
    reportFilingDeadline: string;
    paidOn: string | null;
    amountCents: number;
    status: TaxObligationStatus;
    obligation: string | null;
    paymentStatus: PaymentStatus;
    risk: Risk;
    nextAction: string | null;
    assigneeId: number | null;
    assigneeName: string | null;
    taxReportForm: TaxReportForm;
    state: string | null;
    submissionId: string | null;
    filingDate: string | null;
    document: FileMetaDTO | null;
    customerId: number;
    customerType: CounterpartyType;
    customerName: string;
    customerEmail: string | null;
    comments: TaxObligationCommentDTO[];
    ledger: TaxObligationLedgerRecordDTO[];
    reconciliationRecords: TaxObligationReconciliationRecordDTO[];
    createdByName: string;
    lastModifiedByName: string | null;
    createdAt: string;
    updatedAt: string | null;
    liabilities: TaxObligationLiability[];
    liabilityCents: number;
    paidCents: number;
    balanceDue: number;
    hasPayments: boolean;
    isZeroReport: boolean;
}
